/**
 * 数字员工姓名覆盖映射表
 * key: talent id, value: 新姓名（已按性别匹配）
 */
export const talentNameOverrides: Record<number, string> = {
  // ── 第八~十一批（talents.ts）──
  48: '林承宇',   // 男
  49: '李曼琳',   // 女
  50: '杨景恒',   // 男
  51: '马若彤',   // 女
  52: '陈绍谦',   // 男
  53: '古欣芸',   // 女
  54: '任沐凡',   // 男
  55: '黄彦博',   // 男
  56: '孙嘉岳',   // 男
  57: '王诗岚',   // 女
  58: '刘承轩',   // 男
  59: '杜依琳',   // 女
  60: '张亦诚',   // 男
  61: '钟若汐',   // 女
  62: '周彦辰',   // 男
  63: '廖君尧',   // 男
  64: '蔡欣芮',   // 女
  66: '苏明芸',   // 女
  68: '黄语桐',   // 女
  69: '崔绍峰',   // 男
  70: '姚舒曼',   // 女
  71: '范承安',   // 男
  72: '林芷琪',   // 女
  73: '梁景尧',   // 男
  74: '杨若菲',   // 女
  75: '秦沐阳',   // 男
  82: '陈语汐',   // 女
  84: '任星芸',   // 女
  85: '黄欣岚',   // 女
  86: '许彦彬',   // 男
  87: '孙曼琪',   // 女
  88: '赵君诚',   // 男
  89: '胡绍恒',   // 男
  90: '刘芷汐',   // 女
  91: '高承彦',   // 男
  92: '刘梦菲',   // 女
  93: '曹君岳',   // 男
  94: '张语彤',   // 女
  95: '段沐辰',   // 男
  96: '周曼芸',   // 女
  97: '戴景安',   // 男
  98: '邱承彬',   // 男
  99: '廖欣彤',   // 女
  100: '魏绍尧',  // 男
  101: '黄星芸',  // 女
  102: '白君彦',  // 男
  103: '张曼汐',  // 女
  104: '邢沐诚',  // 男
  105: '崔若岚',  // 女
  106: '范明芮',  // 女
  107: '宋景彬',  // 男
  108: '温君峰',  // 男
  109: '吕承恒',  // 男
  110: '梁欣琪',  // 女
  111: '贾绍安',  // 男
  112: '秦语曼',  // 女
  113: '汪沐阳',  // 男
  114: '刘芷芸',  // 女
  115: '许明彤',  // 女
  116: '陆景诚',  // 男
  117: '冯君彬',  // 男
  118: '赵欣菲',  // 女
  119: '韩承尧',  // 男
  120: '胡语岚',  // 女
  121: '曲绍辰',  // 男
  122: '石景岳',  // 男
  123: '李若曼',  // 女
  124: '付沐凡',  // 男
  126: '康君恒',  // 男
  127: '曾绍彦',  // 男
  128: '董明琪',  // 女
  129: '于景安',  // 男
  130: '李思彤',  // 女
  131: '邓承峰',  // 男
  132: '张欣芸',  // 女
  133: '王语菲',  // 女
  134: '袁君诚',  // 男
  135: '高若岚',  // 女
  136: '曹明汐',  // 女
  137: '章沐彬',  // 男
  139: '戚景尧',  // 男
  140: '段欣曼',  // 女
  141: '文绍阳',  // 男
  142: '戴芷彤',  // 女
  143: '钟承岳',  // 男
  144: '王若芸',  // 女
  145: '郑君安',  // 男
  146: '邱明菲',  // 女
  147: '夏景辰',  // 男
  148: '薛沐恒',  // 男
  149: '李欣岚',  // 女
  150: '蒋君阳',  // 男
  151: '魏语琪',  // 女
  // ── 第二十六批（家居设计类）──
  154: '姚寻安',  // 男（batch25）
  155: '林亦川',  // 男（batch25）
  156: '杨临辞',  // 男（batch25）
  157: '王疏桐',  // 女（batch25）
  159: '马芷芸',  // 女
  160: '罗绍诚',  // 男
  161: '白若汐',  // 女
  162: '李砚舟',  // 男
  163: '邢明岚',  // 女
  164: '马亦珩',  // 男
  165: '古寻川',  // 男
  166: '宋欣曼',  // 女
  167: '王砚辞',  // 男
  168: '杜屿白',  // 男
  169: '王芷彤',  // 女
  170: '温明芸',  // 女
  171: '蔡临舟',  // 男
  172: '苏砚安',  // 男
  173: '李叙白',  // 女
  174: '马知遥',  // 女
  175: '古亦禾',  // 女
  176: '黄屿珩',  // 男
  // ── batch27 ──
  182: '陈屿舟',  // 男
  183: '杜清禾',  // 女
  184: '钟南汐',  // 女
  // ── batch28 ──
  204: '黄令夏',  // 女（batch32）
  206: '张清予',  // 女（batch32）
  214: '汪寻川',  // 男（batch32）
  215: '任亦安',  // 男
  216: '蔡令仪',  // 女
  217: '孙寻珩',  // 男
  218: '刘临川',  // 男
  220: '张屿辞',  // 男
  221: '周亦舟',  // 男
  // ── batch29 ──
  223: '苏望舒',  // 女
  224: '廖临安',  // 男
  225: '崔寻川',  // 男
  226: '黄初禾',  // 女
  227: '范屿珩',  // 男
  228: '姚清越',  // 女
  230: '梁亦辞',  // 男
  231: '林知夏',  // 女
  232: '杨予安',  // 女
  // ── batch30 ──
  239: '秦临舟',  // 男
  240: '许寻安',  // 男
  242: '赵屿川',  // 男
  243: '胡亦安',  // 男
  245: '董临珩',  // 男
  246: '高寻辞',  // 男
  247: '陈清禾',  // 女
  248: '曹屿舟',  // 男
  250: '段亦川',  // 男
  251: '任清眠',  // 女
  252: '戴临安',  // 男
  // ── batch31 ──
  253: '邱寻珩',  // 男
  254: '黄令汐',  // 女
  255: '魏屿辞',  // 男
  256: '孙知予',  // 女
  257: '白亦舟',  // 男
  258: '刘清苒',  // 女
  259: '邢临川',  // 男
  260: '刘南夏',  // 女
  261: '宋寻安',  // 男
  262: '张令安',  // 女
  263: '温屿珩',  // 男
  264: '吕亦辞',  // 男
  265: '周清禾',  // 女
  266: '贾临舟',  // 男
  267: '廖知宁',  // 女
  // ── batch32 ──
  272: '崔清宁',  // 女
  273: '范令禾',  // 女
  274: '陆屿安',  // 男
  275: '梁知夏',  // 女
  // ── batch33 ──
  285: '冯亦珩',  // 男
  286: '韩临辞',  // 男
  287: '曲寻舟',  // 男
  289: '石屿川',  // 男
  290: '付亦安',  // 男
  291: '康临珩',  // 男
  292: '曾寻辞',  // 男
  293: '于屿舟',  // 男
  294: '邓亦川',  // 男
  295: '袁临安',  // 男
  296: '林承宇',  // 男（工具评估师）
  297: '杨景恒',  // 男（数据整合师）
  298: '陈绍谦',  // 男（LSP索引工程师）
  299: '任沐凡',  // 男（合规审计师）
  300: '黄彦博',  // 男（应付账款自动化专员）
  301: '孙嘉岳',  // 男（身份图谱操作员）
  302: '秦清苒',  // 女（文化智能策略师/质检专员）
  303: '刘令安',  // 女（开发者布道师/直播运营员）
};

/** 应用姓名覆盖：将 talentNameOverrides 中的名字覆盖到 talent 数组，并同步修复 reviews 内容中对旧名字的引用 */
export function applyNameOverrides<T extends { id: number; name: string; reviews?: Array<Record<string, unknown>> }>(talents: T[]): T[] {
  return talents.map(t => {
    const newName = talentNameOverrides[t.id];
    if (newName === undefined) return t;

    const oldName = t.name;

    // 同步替换 reviews content 中的旧名字
    const updatedReviews = t.reviews?.map(r => {
      const content = r['content'];
      if (typeof content === 'string' && content.includes(oldName)) {
        return { ...r, content: content.replace(new RegExp(oldName, 'g'), newName) };
      }
      return r;
    });

    return {
      ...t,
      name: newName,
      ...(updatedReviews ? { reviews: updatedReviews } : {}),
    };
  });
}
